import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {useToast} from "../context/toast";
import axiosManager from "../services/axiosManager";

export const useStudentsRequest = (applicationId) => {
    const {t} = useTranslation();
    const toast = useToast();

    const {
        mutateAsync: putStudentsRequest, isPending: isPendingStudentsRequest,
    } = useMutation({
        mutationFn: (bodyData) => axiosManager.put$(`applications/${applicationId}/students`, bodyData).then((response) => response?.data),
        onError: (err) => {
            toast.error(err.status === 400 ? t("errors.requiredFields") : t("errors.common"));
        },
    });

    return {
        putStudentsRequest,
        isPendingStudentsRequest,
    };
};
